<div class="row">

  <div class="col-sm-12">

    <div class="row">

      <div class="col-sm-4">
        <div class="input-group">
          <div class="input-group-prepend">
        <span class="input-group-text">
          {{'Day' | translate}}
        </span>
          </div>
          <input class="form-control" type="number" min="1" max="31" data-cy="birthdayDay" autocomplete="bday-day" (change)="setDate()" [(ngModel)]="day" />
        </div>
      </div>

      <div class="col-sm-4">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">
              {{'Month' | translate}}
            </span>
          </div>
          <select class="form-control" data-cy="birthdayMonth" autocomplete="bday-month" (change)="setDate()" [(ngModel)]="month">
            <option *ngFor="let month of monthList" [value]="month.value">
              {{month.label | translate}}
            </option>
          </select>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="input-group">
          <div class="input-group-prepend">
        <span class="input-group-text">
          {{'Year' | translate}}
        </span>
          </div>
          <select class="form-control" data-cy="birthdayYear" autocomplete="bday-year" (change)="setDate()" [(ngModel)]="year">
            <option *ngFor="let year of yearList" [value]="year.value">{{year.label}}</option>
          </select>
        </div>
      </div>


    </div>

  </div>

</div>
